<template>
</template>
<script>
    import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';

    export default {
        props: [
            'reference',
            'checkoutid',
        ],
        mounted() {
            this.checkPaymentProcessed();
        },
        methods: {
            async checkPaymentProcessed() {
                let vm = this;
                let string = vm.reference;
                if(vm.checkoutid) {
                    string =  vm.reference +'/'+ vm.checkoutid;
                }
                try {
                    setTimeout( async function () {
                        const response = await axios.get('/ajax/check_payment_processed/' + string);

                        if(response.data.success == true)
                        {
                            await navigateWithAttribution('/order-success', { replace: true });
                        }
                        else if (typeof response.data.redirect != 'undefined' && response.data.redirect)
                        {
                            await navigateWithAttribution(response.data.redirect);
                        }
                        else
                        {
                            vm.checkPaymentProcessed();
                        }
                    }, 3000);
                } catch (error) {
                    console.error(error);
                }
            }
        }
    }
</script>